import { render, staticRenderFns } from "./donor-box.vue?vue&type=template&id=67f030ad&scoped=true"
import script from "./donor-box.vue?vue&type=script&lang=ts"
export * from "./donor-box.vue?vue&type=script&lang=ts"
import style0 from "./donor-box.vue?vue&type=style&index=0&id=67f030ad&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67f030ad",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('67f030ad')) {
      api.createRecord('67f030ad', component.options)
    } else {
      api.reload('67f030ad', component.options)
    }
    module.hot.accept("./donor-box.vue?vue&type=template&id=67f030ad&scoped=true", function () {
      api.rerender('67f030ad', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/shared/components/pledge-form/pledge/donor-box.vue"
export default component.exports